import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconOpt: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="opt, option, key"><path fillRule="evenodd" clipRule="evenodd" d="M3 4.75C3 4.33579 3.33579 4 3.75 4H8C8.27316 4 8.52472 4.14852 8.65668 4.38769L16.4428 18.5H20.25C20.6642 18.5 21 18.8358 21 19.25C21 19.6642 20.6642 20 20.25 20H16C15.7268 20 15.4753 19.8515 15.3433 19.6123L7.55722 5.5H3.75C3.33579 5.5 3 5.16421 3 4.75ZM15 4.75C15 4.33579 15.3358 4 15.75 4H20.25C20.6642 4 21 4.33579 21 4.75C21 5.16421 20.6642 5.5 20.25 5.5H15.75C15.3358 5.5 15 5.16421 15 4.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconOpt;
